// Datos del negocio - Fuente: Google Maps (única fuente de verdad)
// NO inventar información adicional

export const businessData = {
  name: "Boulevard Cervecitas",
  fullName: "Boulevard Cervecitas Fenicia",
  type: "Bar",
  address: {
    street: "Av. Francia 168",
    postalCode: "S2002LSO",
    city: "Rosario",
    province: "Santa Fe",
    country: "Argentina",
    full: "Av. Francia 168, S2002LSO Rosario, Santa Fe, Argentina"
  },
  contact: {
    whatsapp: "+5493413433300",
    whatsappDisplay: "+54 9 3413 43-3300"
  },
  schedule: {
    opening: "18:00",
    description: "Abre a las 18:00"
  },
  services: ["Consumo en el lugar", "Para llevar", "Entrega a domicilio"],
  reputation: {
    rating: 4.4,
    totalReviews: 494,
    frequentOpinions: [
      "Buena cerveza",
      "Buena atención",
      "Ambiente cálido",
      "Buena música",
      "Comida rica"
    ]
  },
  products: [
    {
      name: "Cerveza Artesanal",
      description: "Variedad de cervezas artesanales locales"
    },
    {
      name: "Picadas",
      description: "Picada clásica argentina para compartir"
    },
    {
      name: "Comida",
      description: "Platos para acompañar tu cerveza"
    }
  ],
  reviews: [
    {
      text: "Excelente cerveza artesanal y muy buen ambiente.",
      author: "Francisco M."
    },
    {
      text: "Las picadas son increíbles, perfectas para compartir.",
      author: "Carolina S."
    },
    {
      text: "La atención es muy buena y la música genial.",
      author: "Martín R."
    }
  ],
  googleMapsUrl: "https://www.google.com/maps/search/?api=1&query=Boulevard+Cervecitas+Fenicia+Rosario",
  logo: "https://customer-assets.emergentagent.com/job_rosario-craft-beer/artifacts/ccdrxktr_boulevard-cervecitas.jpg",
  heroImage: "https://customer-assets.emergentagent.com/job_cb4f3bbc-8e39-4628-8ed8-386277ee2e22/artifacts/hziebpmd_feniciabar_logo.jpg"
};

export const navigation = [
  { name: "Inicio", href: "#inicio" },
  { name: "Nosotros", href: "#nosotros" },
  { name: "Productos", href: "#productos" },
  { name: "Opiniones", href: "#opiniones" },
  { name: "Contacto", href: "#contacto" }
];
